import {
  GET_WISHLIST,
  WISHLIST_ERROR,
  ADD_WISHLIST_ITEM,
  REMOVE_WISHLIST_ITEM
} from "../actions/types";

const initialState = {
  data: [],
  error: false,
  loading: true
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_WISHLIST:
      return {
        ...state,
        data: payload,
        loading: false
      };
    case ADD_WISHLIST_ITEM:
      return {
        ...state,
        data: [...state.data, payload],
        loading: false
      };
    case REMOVE_WISHLIST_ITEM:
      const newData = state.data.filter(item => item.productId !== payload);
      return {
        ...state,
        data: newData,
        loading: false
      };
    case WISHLIST_ERROR:
      return {
        ...state,
        error: true,
        loading: false
      };
    default:
      return state;
  }
};
